import React, { useContext, useMemo } from 'react';
import {
  HeadingBanner, IconBlock, Icon,
} from 'anf-core-react';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import Tmnt from '../../Tmnt/Tmnt';
import MarketingSpot from '../../Common/MarketingSpot/MarketingSpot';
import AddressForm from '../../Common/AddressForm/AddressForm';
import { getPurxCheckoutConfig } from '../../../tools/utils';

const FORM_CONFIG = [
  {
    label: 'firstName',
    errorMessage: 'firstNameMissing',
    id: 'shipping-first-name',
    name: 'addresses.{mode}.firstName',
    component: 'ADDRESS_INPUT',
    type: 'text',
    visibility: true,
    maxLength: 64,
    validationRule: 'firstName',
    required: true,
    defaultValue: '',
    labelFor: 'shipping-first-name',
    options: null,
  },
  {
    label: 'lastName',
    errorMessage: 'lastNameMissing',
    id: 'shipping-last-name',
    name: 'addresses.{mode}.lastName',
    component: 'ADDRESS_INPUT',
    type: 'text',
    visibility: true,
    maxLength: 64,
    validationRule: 'lastName',
    required: true,
    defaultValue: '',
    labelFor: 'shipping-last-name',
    options: null,
  },
];

export default function PopinsPickupOrder() {
  const {
    checkoutPageState,
  } = useContext(CheckoutPageContext);
  const {
    shippingAddress,
    textFor,
    eSpots,
    shipMethod,
  } = checkoutPageState;
  const { hasSteppedCheckout } = getPurxCheckoutConfig();

  const addressConfigData = useMemo(() => {
    const shipModeType = shipMethod?.shipModeType;
    return {
      id: 'shipping',
      fields: FORM_CONFIG.map((field) => {
        const label = textFor?.[field.label]
          ?? { key: field.label, value: field.label };
        const error = textFor?.[field.errorMessage]
          ?? { key: field.errorMessage, value: field.errorMessage };
        return {
          ...field,
          name: field.name.replace('{mode}', shipModeType?.toLowerCase()),
          label,
          error,
        };
      }),
    };
  }, [shipMethod, textFor]);

  const currentDate = useMemo(() => Date(), []);

  const errorTmnts = useMemo(() => ({
    firstNameMissing: textFor?.firstNameMissing,
    lastNameMissing: textFor?.lastNameMissing,
    enterValidField: textFor?.enterValidField,
  }), [textFor]);

  const isPopins = useMemo(() => shipMethod?.shipModeType === 'Popins', [shipMethod]);

  if (!shippingAddress && !textFor) {
    return null;
  }

  return (
    <section id="shipping-info" className="shipping-info popins-pickuporder" data-testid="popinsPickupOrder">
      <HeadingBanner>
        { hasSteppedCheckout ? (
          <h3 data-property={textFor.whoIsPickingUpOrder?.key}>
            {textFor.whoIsPickingUpOrder?.value}
          </h3>
        ) : (
          <h2 data-property={textFor.whoIsPickingUpOrder?.key}>
            {textFor.whoIsPickingUpOrder?.value}
          </h2>
        )}
      </HeadingBanner>

      <AddressForm
        addressConfig={addressConfigData}
        type="shipping"
        fieldInFix="homeDelivery"
        errorTmnts={errorTmnts}
      />
      <div
        id="checkout_popinsmessage"
        className="genericESpot js-aem-content aem-content aem-enabled"
        data-espotname="checkout_popinsmessage"
        data-aem-switch="3"
        data-aem-currency=""
        data-cachets={currentDate}
      />
      {isPopins && (
        <>
          <MarketingSpot
            espotId="checkout_popinsmessage"
            espotData={eSpots?.checkoutPopinsMessage}
          />
          <div className="poping-instruction">
            <IconBlock icon={<Icon icon="clock" size="s" className="social-proofing-icon" />}>
              <Tmnt tmnt={textFor?.popinsInstructionBodyUs} />
            </IconBlock>
          </div>
        </>
      )}
    </section>
  );
}
